
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.3 10.7H4.31a1.5 1.5 0 00-1.5 1.5v2.89a1.5 1.5 0 001.5 1.5h2.97a1.5 1.5 0 001.5-1.5v-2.88a1.5 1.5 0 00-1.5-1.5zm.5 4.39a.5.5 0 01-.5.5H4.31a.5.5 0 01-.5-.5v-2.88a.5.5 0 01.5-.5h2.97a.5.5 0 01.5.5zm7.92-4.39h-4.65a.5.5 0 000 1h4.65a.5.5 0 000-1zm-.92 2.45h-3.73a.5.5 0 000 1h3.72a.5.5 0 000-1zm-.94 2.44h-2.79a.5.5 0 000 1h2.79a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M22.33 3.9h-3.16v-1A1.92 1.92 0 0017.23 1H1.91A1.9 1.9 0 000 2.88v17.97A2.17 2.17 0 002.18 23h18.57l.78-.01A2.52 2.52 0 0024 20.43V5.56a1.66 1.66 0 00-1.67-1.65zM2.18 22A1.17 1.17 0 011 20.85V2.88A.9.9 0 011.9 2h15.33a.92.92 0 01.94.9v17.53a2.54 2.54 0 00.55 1.57zM23 20.43a1.52 1.52 0 01-1.48 1.56l-.78.01a1.61 1.61 0 01-1.57-1.57V4.9h3.16a.66.66 0 01.67.65z"}}),_c('path',{attrs:{"d":"M15.72 7.35H3.36a.5.5 0 000 1h12.36a.5.5 0 000-1z"}})])
          )
        }
      }
    